import InfiniteScroll from '@Components/General/InfiniteScroll';
import GridSkeleton from '@Components/General/Skeletons/grid';
import { DashboardRounded } from '@mui/icons-material';
import { Avatar, Box, Card, CardHeader } from '@mui/material';
import { maxToneToLevel } from '@utils/colorUtils';
import { forwardRef } from 'react';

const TemplateCard = forwardRef(({ template, onSelect }, ref) => {
    return (
        <Card
            ref={ref}
            variant="elevation"
            onClick={() => onSelect(template.template)}
            sx={{ cursor: 'pointer' }}
        >
            <Avatar
                sx={{
                    width: '100%',
                    height: 196,
                    bgcolor: maxToneToLevel(template.background_color, 94),
                    borderRadius: 'inherit',
                }}
                src={template.thumbnail}
            >
                <DashboardRounded sx={{ fontSize: 164 }} />
            </Avatar>
            <CardHeader
                title={template.title}
                titleTypographyProps={{
                    noWrap: true,
                    variant: 'titleLarge',
                }}
                sx={{
                    '& .MuiCardHeader-content': {
                        overflow: 'hidden',
                    },
                }}
                // action={
                //     <Box onClick={e => e.stopPropagation()}>
                //         <QuickOptions size="small" options={quickOptions} />
                //     </Box>
                // }
            />
        </Card>
    );
});

const GridBox = ({ children }) => (
    <Box
        display="grid"
        gap={2}
        gridTemplateColumns="repeat(auto-fill, minmax(196px, 1fr))"
    >
        {children}
    </Box>
);

const TemplateList = ({
    templates,
    loadMore,
    loadingNext,
    isLoading,
    onSelect,
}) => {
    if (isLoading) {
        return <GridSkeleton />;
    }

    return (
        <InfiniteScroll
            ListComponent={GridBox}
            loadMore={loadMore}
            loading={loadingNext}
        >
            {templates.map(template => (
                <TemplateCard
                    key={template.id}
                    template={template}
                    onSelect={onSelect}
                />
            ))}
        </InfiniteScroll>
    );
};

export default TemplateList;
